import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { PrismicService } from "./prismic.service";


@Injectable({
  providedIn: "root",
})
export class PaypalSettingsService {

  constructor(    private prismicService: PrismicService,) {}

  loadScriptTag(): void {
    const env = environment.production ? "prod" : "dev";
    const prismicEnv = this.prismicService.getEnvironment(env);
    const paypalConfig = this.prismicService.getValidatedPaypalConfig(prismicEnv);
    if (!paypalConfig) {
      return;
    }

    console.log("prismicEnv: ", prismicEnv);
    const paypal = document.createElement('script');
    paypal.setAttribute('type','text/javascript');
    const paypalUrl = new URL("https://www.paypal.com/sdk/js");
    paypalUrl.search = new URLSearchParams({
      "client-id": paypalConfig.clientId,
      "merchant-id": paypalConfig.merchantId,
      intent: "authorize",
      currency: "USD",
      "disable-funding": "credit,card",
      commit: "false",
    }).toString();
    paypal.setAttribute('src', paypalUrl.toString());
    document.documentElement.firstChild.appendChild(paypal);

  }
}
